export const IconSuccess = (props) => (
<svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1453_35982)">
        <path d="M31.6078 46.2156C31.5899 46.2156 31.572 46.2156 31.5531 46.2148C30.856 46.2003 30.1948 45.9021 29.7224 45.3887L16.8229 31.3795C15.8644 30.3381 15.931 28.7167 16.9724 27.7582C18.0146 26.7997 19.6352 26.8672 20.5937 27.9078L31.6865 39.9556L62.4316 9.29145C63.432 8.2919 65.0551 8.29363 66.0554 9.2957C67.055 10.2978 67.0532 11.9209 66.0502 12.9204L33.4171 45.4681C32.937 45.9465 32.2853 46.2156 31.6078 46.2156Z" fill="url(#paint0_linear_1453_35982)" />
        <path d="M34 68C15.2522 68 0 52.747 0 34C0 15.2522 15.2522 0 34 0C35.4155 0 36.5628 1.14723 36.5628 2.56275C36.5628 3.97827 35.4155 5.12563 34 5.12563C18.079 5.12563 5.12563 18.079 5.12563 34C5.12563 49.922 18.079 62.8744 34 62.8744C49.922 62.8744 62.8744 49.922 62.8744 34C62.8744 32.5845 64.0216 31.4373 65.4371 31.4373C66.8526 31.4373 67.9999 32.5845 67.9999 34C68 52.747 52.747 68 34 68Z" fill="url(#paint1_linear_1453_35982)" />
    </g>
    <defs>
        <linearGradient id="paint0_linear_1453_35982" x1="16.1455" y1="27.3806" x2="66.8064" y2="27.3806" gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5665B" />
            <stop offset="0.00022375" stop-color="#E5665B" />
            <stop offset="0.2" stop-color="#BC2DBD" />
            <stop offset="0.201284" stop-color="#BC2DBD" />
            <stop offset="0.51" stop-color="#5F00A7" />
            <stop offset="0.512073" stop-color="#5F00A7" />
            <stop offset="0.72" stop-color="#393DB8" />
            <stop offset="0.720835" stop-color="#393DB8" />
            <stop offset="1" stop-color="#048ACC" />
        </linearGradient>
        <linearGradient id="paint1_linear_1453_35982" x1="0" y1="34.0023" x2="68.0034" y2="34.0023" gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5665B" />
            <stop offset="0.00022375" stop-color="#E5665B" />
            <stop offset="0.2" stop-color="#BC2DBD" />
            <stop offset="0.201284" stop-color="#BC2DBD" />
            <stop offset="0.51" stop-color="#5F00A7" />
            <stop offset="0.512073" stop-color="#5F00A7" />
            <stop offset="0.72" stop-color="#393DB8" />
            <stop offset="0.720835" stop-color="#393DB8" />
            <stop offset="1" stop-color="#048ACC" />
        </linearGradient>
        <clipPath id="clip0_1453_35982">
            <rect width="68" height="68" fill="white" />
        </clipPath>
    </defs>
</svg>
);
